import { render } from "./bulk_uploader.vue?vue&type=template&id=3ea96938&scoped=true&ts=true"
import script from "./bulk_uploader.vue?vue&type=script&lang=ts"
export * from "./bulk_uploader.vue?vue&type=script&lang=ts"

import "./bulk_uploader.vue?vue&type=style&index=0&id=3ea96938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea96938"]])

export default __exports__